// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset style sheet */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  padding: 0;
  margin: 0;
  font-size: 100%;
  vertical-align: baseline;
  border: 0;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  padding: 0;
  margin: 0;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote::before,
blockquote::after,
q::before,
q::after {
  content: "";
  content: none;
}
table {
  border-spacing: 0;
  border-collapse: collapse;
}
html,
body,
#root {
  width: 100%;
  height: 100%;
}
/*全局隐藏滚动条*/
html {
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}
html::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}
`, "",{"version":3,"sources":["webpack://./src/styles/reset.less"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFC,UAAA;EACA,SAAA;EAEA,eAAA;EACA,wBAAA;EACA,SAAA;AAAD;AACA,gDAAgD;AAGhD;;;;;;;;;;;EAWC,cAAA;AADD;AAGA;EACC,UAAA;EACA,SAAA;AADD;AAGA;;EAEC,gBAAA;AADD;AAGA;;EAEC,YAAA;AADD;AAGA;;;;EAIC,WAAA;EACA,aAAA;AADD;AAGA;EACC,iBAAA;EACA,yBAAA;AADD;AAGA;;;EAGC,WAAA;EACA,YAAA;AADD;AACA,UAAU;AAGV;EACC,qBAAA;EADC,YAAY;EAEb,wBAAA;EAAC,WAAW;AACb;AAEA;EACC,aAAA;EAAC,kBAAkB;AACpB","sourcesContent":["/* Reset style sheet */\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n\tpadding: 0;\n\tmargin: 0;\n\t//font: inherit;\n\tfont-size: 100%;\n\tvertical-align: baseline;\n\tborder: 0;\n}\n\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n\tdisplay: block;\n}\nbody {\n\tpadding: 0;\n\tmargin: 0;\n}\nol,\nul {\n\tlist-style: none;\n}\nblockquote,\nq {\n\tquotes: none;\n}\nblockquote::before,\nblockquote::after,\nq::before,\nq::after {\n\tcontent: \"\";\n\tcontent: none;\n}\ntable {\n\tborder-spacing: 0;\n\tborder-collapse: collapse;\n}\nhtml,\nbody,\n#root {\n\twidth: 100%;\n\theight: 100%;\n}\n/*全局隐藏滚动条*/\nhtml {\n\tscrollbar-width: none; /* Firefox */\n\t-ms-overflow-style: none; /* IE 10+ */\n}\n\nhtml::-webkit-scrollbar {\n\tdisplay: none; /* Chrome Safari */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
